import React from 'react';

const SideNavVirtualListWrapper = ({ children }) => (
  <div className="side-nav-virtual-list-wrapper">{children}</div>
);

export default SideNavVirtualListWrapper;
